import { ListItem, ListItemText } from '@material-ui/core';

import { SwitchModeIOS } from 'shared/components';

import { useCardCustomization } from './hooks';

import makeClasses from './CardCustomization.style';

import type { ReactNode } from 'react';
import type { IMenuCustomization } from 'features/menu-page/domain';

export function CardCustomization(props: Props) {
  const { customization, title, renderIndex, children, toggleOnOff } = props;

  const { lang } = useCardCustomization();

  const _classes = makeClasses();

  return (
    <ListItem
      component='article'
      data-custom-item-id={customization.id}
      classes={{ root: _classes.item }}
    >
      <ListItemText
        primary={title ?? `${lang.item.title} ${renderIndex + 1}`}
        secondary={customization.description}
        classes={{
          multiline: _classes.textMultiline,
          primary: _classes.textPrimary,
          secondary: _classes.textSecondary,
        }}
      />

      {children}

      <section className={_classes.onOff}>
        <SwitchModeIOS
          color='secondary'
          checked={customization.isOn}
          id={`switch-custom-item-${customization.id}`}
          onCheck={checked => toggleOnOff(checked, customization)}
        />
      </section>
    </ListItem>
  );
}

interface Props {
  customization: IMenuCustomization;
  title?: ReactNode;
  renderIndex: number;
  children?: ReactNode;
  toggleOnOff: (c: boolean, item: IMenuCustomization) => void;
}
